<div class="section-block">
  <div class="section-header">
    <span class="section-title">{{ title }}</span>
  </div>
  <div class="section-content">
    <ng-content></ng-content>
  </div>
</div>
